"use strict";

import _ from "lodash";
import AppConstants from "../constants/AppConstants";

class HTMLUtils {
  static formatToValidHTML(/** String **/ html, /** Object **/ opts) {
    let parser = new DOMParser();

    //wrap content in a div to make it easier to find
    let toValidate = "<div id='si-html-val-5'>" + html + "</div>";

    let doc = parser.parseFromString(toValidate, "text/html");

    let domElement = doc.getElementById("si-html-val-5");

    let result = {};

    //if formatted doesn't exist the dom parser failed to convert the string to HTML
    if (domElement) {
      result.text = domElement.innerHTML;
      if (_.has(opts, "sample")) {
        result.sample = domElement.textContent.substr(0, _.get(opts, "sample", 30));
      }
    } else {
      throw new Error("Unable to format HTML");
    }

    return result;
  }

  static formatURL(/** String **/ url) {
    if (!_.isEmpty(url)) {
      if (!/^(https?):\/\/?/gim.test(url)) {
        url = "https://" + url;
      }
    }

    return url;
  }

  static toQueryString(obj, joinSymbol = "&") {
    return _.map(obj, function (v, k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(v);
    }).join(joinSymbol);
  }
}

export const checkUpdateForCustomHtml = ({ content, update, element, elementId }) => {
  // list elements are not allowed in p or h1-h6 elements so set to div

  if (content.text.indexOf("<li>") > -1) {
    if (element.get(AppConstants.CUSTOM_TAG_DISABLED) !== 1) {
      update.add(elementId, "tag", "div");
      update.add(elementId, AppConstants.CUSTOM_TAG_DISABLED, 1);
    }
  } else if (element.get(AppConstants.CUSTOM_TAG_DISABLED) === 1) {
    update.add(elementId, AppConstants.CUSTOM_TAG_DISABLED, null);
  }
  return update;
};

export const replaceBRTags = (string) => {
  return string.replace(/<br\s*\/?>/gi, " ");
};

export const removeHtmlFromString = (string) => {
  return string.replace(/<\/?[^>]+(>|$)/g, "");
};

/**
 * Determines if the platform-specific modifier key is pressed
 * (Cmd on Mac, Ctrl on Windows/Linux)
 * @param {KeyboardEvent | WheelEvent | MouseEvent} event - The event object
 * @returns {boolean} True if the modifier key is pressed
 */
export const isModifierKeyPressed = (event) => {
  const isMac = navigator.userAgent.includes("Mac");
  return isMac ? event.metaKey : event.ctrlKey;
};

/**
 * Returns the platform-specific modifier key symbol
 * ('⌘' on Mac, '⌃' on Windows/Linux)
 * @returns {string} The modifier key symbol
 */
export const getModSymbol = () => {
  const isMac = navigator.userAgent.includes("Mac");
  return isMac ? "⌘" : "⌃";
};

// Body content plus its own <style>, for painting into an already-open document.
export const loadingFragment = (message) => `<style>body{display:flex;flex-direction:column;justify-content:center;align-items:center;height:90vh;margin:0;font-family:Arial,sans-serif;background-color:#1a1a1a;color:#969696}h3{font-weight:400;margin-top:1rem}.spinner{width:30px;height:30px;-webkit-animation:loading .6s linear infinite;animation:loading .6s linear infinite}.spinner path{fill:#2e97c2}@keyframes loading{100%{transform:rotate(360deg)}}</style><svg class=loading-logo version=1.1 viewBox="0 0 600 500"xmlns=http://www.w3.org/2000/svg style=display:block;position:absolute;top:20px;left:25px;width:125px;height:125px><g style=fill:#fff><path d="M589.8,33.7h-56.2c-0.6,0-1,0.4-1,1v10.9c0,0.6,0.4,1,1,1h21.3v58.6c0,0.6,0.4,1,1,1h11.6c0.6,0,1-0.4,1-1 V46.7h21.3c0.6,0,1-0.4,1-1V34.7C590.8,34.2,590.3,33.7,589.8,33.7z"></path><path d="M517.1,33.7h-11.5c-0.6,0-1,0.4-1,1v70.5c0,0.6,0.4,1,1,1h11.5c0.6,0,1-0.4,1-1V34.7 C518.1,34.2,517.7,33.7,517.1,33.7z"></path><path d="M490.5,33.7h-12.1c-0.4,0-0.8,0.3-0.9,0.7l-13.6,48.3l-13.9-48.5c-0.1-0.4-0.5-0.7-1-0.7h-7.1 c-0.4,0-0.8,0.3-1,0.7L427,82.7l-13.6-48.3c-0.1-0.4-0.5-0.7-0.9-0.7h-12.4c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.3-0.2,0.6-0.1,0.9 l22.2,71c0.1,0.4,0.5,0.7,0.9,0.7h9.1c0.4,0,0.8-0.3,0.9-0.7l12.9-46.9l12.9,46.9c0.1,0.4,0.5,0.7,0.9,0.7h9.2 c0.4,0,0.8-0.3,0.9-0.7l22.2-71c0.1-0.3,0.1-0.6-0.1-0.9C491.1,33.9,490.8,33.7,490.5,33.7z"></path><path d="M356.1,32.6c-20.8,0-37,16.5-37,37.5c0,21.3,15.8,37.3,36.8,37.3c20.8,0,37-16.5,37-37.5 C392.9,48.6,377.1,32.6,356.1,32.6z M356.1,94.5c-13.2,0-23.2-10.6-23.2-24.6c0-13.9,9.9-24.4,23-24.4c13.2,0,23.2,10.6,23.2,24.6 C379.1,84,369.2,94.5,356.1,94.5z"></path><path d="M302.5,33.7H291c-0.6,0-1,0.4-1,1v28.5h-32.4V34.7c0-0.6-0.4-1-1-1h-11.5c-0.6,0-1,0.4-1,1v70.5 c0,0.6,0.4,1,1,1h11.5c0.6,0,1-0.4,1-1V76.3H290v28.9c0,0.6,0.4,1,1,1h11.5c0.6,0,1-0.4,1-1V34.7C303.5,34.2,303.1,33.7,302.5,33.7 z"></path><path d="M205.1,63.5C205.1,63.5,205.1,63.5,205.1,63.5c-15.7-3.4-15.7-6.8-15.7-10.1c0-4.6,4.6-7.8,11.2-7.8 c6.3,0,11.8,2.1,17.3,6.5l1.6,1.3c0.2,0.2,0.5,0.3,0.8,0.2c0.3,0,0.5-0.2,0.7-0.4l6.8-9c0.3-0.4,0.2-1-0.2-1.4l-1.5-1.2 c-7.7-6.2-15.3-8.8-25.2-8.8c-14.4,0-24.8,8.9-24.8,21.2c0,14,9.9,19,24.7,22.2c14.9,3.1,14.9,6.7,14.9,9.8c0,5-4.8,8.4-11.8,8.4 c-8,0-14-2.5-20.8-8.6l-1.5-1.4c-0.2-0.2-0.5-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.4l-7.2,8.6c-0.3,0.4-0.3,1,0.1,1.4l1.5,1.3 c8.7,7.8,18,11.4,29.2,11.4c15.1,0,25.7-9,25.7-21.9C229.1,73.7,222,67.1,205.1,63.5z"></path></g><g style=fill:#fff><rect height=67.7 width=92.3 x=26.4 y=36.5></rect></g><g style=fill:#2e97c2><path d="M73.2,6c-35.3,0-64,28.7-64,64c0,35.3,28.7,64,64,64c35.3,0,64-28.7,64-64C137.2,34.7,108.6,6,73.2,6z M93.5,74.8c-0.1,5.3-2,10.7-5.3,15.3c-3.3,4.5-7.8,7.8-12.3,8.9l-0.1,0H33l0-0.9c-0.2-4.8,1.7-10.4,5.4-15.3c3.5-4.6,8.1-8,12.2-9 l0.1,0h42.8L93.5,74.8z M113.5,41.9c-0.1,5.3-2,10.7-5.3,15.3c-3.3,4.5-7.8,7.8-12.3,8.9l-0.1,0H53l0-0.9 c-0.2-4.8,1.7-10.4,5.4-15.3c3.5-4.6,8.1-8,12.2-9l0.1,0h42.8L113.5,41.9z"></path></g></svg> <svg class=spinner version=1.1 viewBox="0 0 20 20"xmlns=http://www.w3.org/2000/svg x=0px y=0px><path d=M10,0C4.5,0,0.5,4.5,0.5,10c0,4.9,4.5,9,9.5,9c-4.4,0-8.5-4.2-8.5-9c0-4.4,4.1-8,8.5-8c0.6,0,1-0.4,1-1C11,0.4,10.6,0,10,0z></path></svg><h3>${message}</h3>`;

// used to display a loading page when opening a new tab with window.open()
/**
 * Claims a new tab on the user's click (popup blockers reject tabs opened after
 * an async gap) and paints it with a loading screen.
 * @param {string} message
 * @returns {Window | null} the tab, or null when popup-blocked.
 */
export const openLoadingTab = (message) => {
  const tab = window.open("", "_blank");
  if (tab) {
    tab.document.title = "Loading...";
    tab.document.body.innerHTML = loadingFragment(message);
  }
  return tab;
};

export default HTMLUtils;
